import { useState, useCallback, useRef } from "react";
import CreateLessonByTeacher from "../components/CreateLessonByTeacher";
import CreateLessonByStudent from "../components/CreateLessonByStudent";
import { axiosClient } from "../api/proxy/AxiosClient";
import { ScheduleProvider } from "./ScheduleService";
import EditLesson from "../components/EditLesson";

export const useLessonService = (auth) => {
  
  const [isOpen, setIsOpen] = useState(false);
  const selectedStudentsRef = useRef([]);
  const scheduleRef = useRef({ start: null, end: null });
  const [modalProps, setModalProps] = useState({});
  const [teacher, setTeacher] = useState(null);
  const [mode, setMode] = useState(null);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [lessons, setLessons] = useState([]);

  const openCreateLessonForTeacher = useCallback((initialStudents = [], students, range, setNewLesson = () => {}) => {
    selectedStudentsRef.current = initialStudents;
    setIsOpen(true);
    setMode("createLessonByTeacher");
    if (range) {
      scheduleRef.current = { start: range.start, end: range.end };
    }
    setModalProps({ students, setNewLesson });
  }, []);

  const openCreateLessonForStudent = useCallback((selectedTeacher, teachers, range, setNewLesson = () => {}) => {
    setIsOpen(true);
    setMode("createLessonByStudent");
    setTeacher(selectedTeacher);
    if (range) {
      scheduleRef.current = { start: range.start, end: range.end };
    }
    setModalProps({ teachers, setNewLesson });
  }, []);

  const openEditLessonForTeacher = useCallback((lesson, lessons, setChangedLesson) => {
    setIsOpen(true);
    setMode("editLessonByTeacher");
    setSelectedLesson(lesson);
    setLessons(lessons);
    setModalProps({ setChangedLesson });
  }, []);

  const openEditLessonForStudent = useCallback((lesson, lessons, setChangedLesson) => {
    setIsOpen(true);
    setMode("editLessonByStudent");
    setSelectedLesson(lesson);
    setLessons(lessons);
    setModalProps({ setChangedLesson });
  }, []);

  const closeCreateLesson = useCallback(() => {
    setIsOpen(false);
    selectedStudentsRef.current = [];
    scheduleRef.current = { start: null, end: null };
  }, []);

  const saveLesson = (lessonData) => {
    return axiosClient.post("/lessons", lessonData);
  };

  const LessonModal = () => (
    mode === "createLessonByTeacher" ?
      <ScheduleProvider>
      <CreateLessonByTeacher
        open={isOpen}
        onClose={closeCreateLesson}
        onSave={saveLesson}
        selectedStudentsRef={selectedStudentsRef}
        setNewLesson={modalProps.setNewLesson}
        scheduleRef={scheduleRef}
        users={modalProps.students}
      />
      </ScheduleProvider>
      : mode === "createLessonByStudent" ? 
      <ScheduleProvider>
      <CreateLessonByStudent
        open={isOpen}
        onClose={closeCreateLesson}
        onSave={saveLesson}
        selectedTeacher={teacher}
        setSelectedTeacher={setTeacher}
        setNewLesson={modalProps.setNewLesson}
        scheduleRef={scheduleRef}
        users={modalProps.teachers}
      />
      </ScheduleProvider>
      : mode === "editLessonByTeacher" ?
      <ScheduleProvider>
      <EditLesson
        open={isOpen}
        onClose={closeCreateLesson}
        selectedLesson={selectedLesson}
        setSelectedLesson={setSelectedLesson}
        scheduleRef={scheduleRef}
        lessons={lessons}
        setLessons={setLessons}
        setChangedLesson={modalProps.setChangedLesson}
        role="teacher"
        onActionPerformed={closeCreateLesson}
      />
      </ScheduleProvider>
      : mode === "editLessonByStudent" ?
      <ScheduleProvider>
      <EditLesson
        open={isOpen}
        onClose={closeCreateLesson}
        selectedLesson={selectedLesson}
        setSelectedLesson={setSelectedLesson}
        scheduleRef={scheduleRef}
        lessons={lessons}
        setLessons={setLessons}
        setChangedLesson={modalProps.setChangedLesson}
        role="student"
        onActionPerformed={closeCreateLesson}
      />
      </ScheduleProvider>
      :
      <></>
  );

  return {
    openCreateLessonForTeacher,
    openCreateLessonForStudent,
    openEditLessonForTeacher,
    openEditLessonForStudent,
    closeCreateLesson,
    saveLesson,
    LessonModal,
    selectedStudentsRef,
    scheduleRef,
  };
};
